import {
	collection,
	getDocs,
	addDoc,
	updateDoc,
	deleteDoc,
	doc,
	Firestore,
	query,
	where,
} from "firebase/firestore";
import { useEffect, useState } from "react";
import Modal from "react-modal";
import { db } from "../../../firebase-config";
import { Alert } from "react-bootstrap";
import Wait from "../../../resources/wait.gif";
import { modalStyle } from "../../utils/shared";

function ClubModal(props) {
	const ClubsCollectionRef = collection(db, "clubs");

	const [isLoadingModal, setLoadingModal] = useState(false);
	const [error, setError] = useState(null); // Assign string to state if error occurs

	// form values
	const [uid, setUid] = useState("");
	const [Address, setAddress] = useState("");
	const [City, setCity] = useState("");
	const [State, setState] = useState("");
	const [ZIP, setZIP] = useState("");
	const [club_id, setClub_id] = useState("");
	const [club_name, setClub_name] = useState("");
	const [id, setId] = useState("");
	const [league_name, setLeague_name] = useState("");
	const [phone, setPhone] = useState("");
	const [website, setWebsite] = useState("");
	const [monday_in, setMonday_in] = useState("");
	const [monday_out, setMonday_out] = useState("");
	const [tuesday_in, setTuesday_in] = useState("");
	const [tuesday_out, setTuesday_out] = useState("");
	const [wednesday_in, setWednesday_in] = useState("");
	const [wednesday_out, setWednesday_out] = useState("");
	const [thursday_in, setThursday_in] = useState("");
	const [thursday_out, setThursday_out] = useState("");
	const [friday_in, setFriday_in] = useState("");
	const [friday_out, setFriday_out] = useState("");
	const [saturday_in, setSaturday_in] = useState("");
	const [saturday_out, setSaturday_out] = useState("");
	const [sunday_in, setSunday_in] = useState("");
	const [sunday_out, setSunday_out] = useState("");

    const club = props.club;
	useEffect(() => {
		if(!club) return;
        console.log("club", club);
        setClub_name(club["club_name"]);
        setLeague_name(club["league_name"]);
        setPhone(club["phone"]);
        setWebsite(club["website"]);
        // schedule
        setMonday_in(club["monday_in"]);
        setMonday_out(club["monday_out"]);
        setTuesday_in(club["tuesday_in"]);
        setTuesday_out(club["tuesday_out"]);
        setWednesday_in(club["wednesday_in"]);
        setWednesday_out(club["wednesday_out"]);
        setThursday_in(club["thursday_in"]);
        setThursday_out(club["thursday_out"]);
        setFriday_in(club["friday_in"]);
        setFriday_out(club["friday_out"]);
        setSaturday_in(club["saturday_in"]);
        setSaturday_out(club["saturday_out"]);
        setSaturday_in(club["saturday_in"]);
        setSaturday_out(club["saturday_out"]);
        setSunday_in(club["sunday_in"]);
        setSunday_out(club["sunday_out"]);
	}, [club]);

	const updateClub = async () => {
		setLoadingModal(true);
		const userDoc = doc(db, "clubs", uid); // user should own club they are updating?
		var date = new Date();
		const newFields = {
			date_modified: date,
			by: props.userData.name + " " + props.userData.lastname,
			uid: props.userHome.uid,
			Address: Address,
			City: City,
			State: State,
			ZIP: ZIP,
			club_id: club_id,
			club_name: club_name,
			uid: id,
			league_name: league_name,
			phone: phone,
			website: website,
			monday_in: monday_in,
			monday_out: monday_out,
			tuesday_in: tuesday_in,
			tuesday_out: tuesday_out,
			wednesday_in: wednesday_in,
			wednesday_out: wednesday_out,
			thursday_in: thursday_in,
			thursday_out: thursday_out,
			friday_in: friday_in,
			friday_out: friday_out,
			saturday_in: saturday_in,
			saturday_out: saturday_out,
			sunday_in: sunday_in,
			sunday_out: sunday_out,
			status: "Active",
		};
		await updateDoc(userDoc, newFields).then(() => {
			setLoadingModal(false);
			props.finalize(); // unmount from parent component
		});
	};

	const saveClub = async () => {
		setLoadingModal(true);
		var date = new Date();
		await addDoc(ClubsCollectionRef, {
			date: date,
			uid: props.userHome.uid,
			Address: Address,
			City: City,
			State: State,
			ZIP: ZIP,
			club_id: club_id,
			club_name: club_name,
			league_name: league_name,
			phone: phone,
			website: website,
			monday_in: monday_in,
			monday_out: monday_out,
			tuesday_in: tuesday_in,
			tuesday_out: tuesday_out,
			wednesday_in: wednesday_in,
			wednesday_out: wednesday_out,
			thursday_in: thursday_in,
			thursday_out: thursday_out,
			friday_in: friday_in,
			friday_out: friday_out,
			saturday_in: saturday_in,
			saturday_out: saturday_out,
			sunday_in: sunday_in,
			sunday_out: sunday_out,
			status: "Active",
		}).then((res) => {
			setLoadingModal(false);
		});
	};

	return (
		<Modal
			isOpen={true}
			onAfterOpen={null}
			onRequestClose={null}
			style={modalStyle}
			contentLabel="Example Modal"
			closeTimeoutMS={500}
		>
			<h2>{props.action}</h2>
			<div className="row">
				<div className="col-lg-6">
					<label>Club Name</label>
					<input
						type="text"
						id="programname"
						className="form-control"
						value={club_name}
						onChange={(event) => {
							setClub_name(event.target.value);
						}}
					></input>
				</div>
				<div className="col-lg-6">
					<label>League Name</label>
					<input
						type="text"
						id="programname"
						className="form-control"
						value={league_name}
						onChange={(event) => {
							setLeague_name(event.target.value);
						}}
					></input>
				</div>
				<div className="col-lg-6">
					<label>Phone</label>
					<input
						type="text"
						id="programname"
						className="form-control"
						value={phone}
						onChange={(event) => {
							setPhone(event.target.value);
						}}
					></input>
				</div>
				<div className="col-lg-6">
					<label>Website(URL)</label>
					<input
						type="text"
						id="programname"
						className="form-control"
						value={website}
						onChange={(event) => {
							setWebsite(event.target.value);
						}}
					></input>
				</div>
				<div className="col-lg-6">
					<label>Operation Hours</label>
				</div>
				<div className="col-lg-3">
					<label>Open</label>
				</div>
				<div className="col-lg-3">
					<label>Close</label>
				</div>
				<div className="col-lg-6">
					<label>Monday</label>
				</div>
				<div className="col-lg-3">
					<input
						type="time"
						id="programname"
						className="form-control"
						value={monday_in}
						onChange={(event) => {
							setMonday_in(event.target.value);
						}}
					></input>
				</div>
				<div className="col-lg-3">
					<input
						type="time"
						id="programname"
						className="form-control"
						value={monday_out}
						onChange={(event) => {
							setMonday_out(event.target.value);
						}}
					></input>
				</div>
				<div className="col-lg-6">
					<label>Tuesday</label>
				</div>
				<div className="col-lg-3">
					<input
						type="time"
						id="programname"
						className="form-control"
						value={tuesday_in}
						onChange={(event) => {
							setTuesday_in(event.target.value);
						}}
					></input>
				</div>
				<div className="col-lg-3">
					<input
						type="time"
						id="programname"
						className="form-control"
						value={tuesday_out}
						onChange={(event) => {
							setTuesday_out(event.target.value);
						}}
					></input>
				</div>
				<div className="col-lg-6">
					<label>Wednesday</label>
				</div>
				<div className="col-lg-3">
					<input
						type="time"
						id="programname"
						className="form-control"
						value={wednesday_in}
						onChange={(event) => {
							setWednesday_in(event.target.value);
						}}
					></input>
				</div>
				<div className="col-lg-3">
					<input
						type="time"
						id="programname"
						className="form-control"
						value={wednesday_out}
						onChange={(event) => {
							setWednesday_out(event.target.value);
						}}
					></input>
				</div>
				<div className="col-lg-6">
					<label>Thursday</label>
				</div>
				<div className="col-lg-3">
					<input
						type="time"
						id="programname"
						className="form-control"
						value={thursday_in}
						onChange={(event) => {
							setThursday_in(event.target.value);
						}}
					></input>
				</div>
				<div className="col-lg-3">
					<input
						type="time"
						id="programname"
						className="form-control"
						value={thursday_out}
						onChange={(event) => {
							setThursday_out(event.target.value);
						}}
					></input>
				</div>
				<div className="col-lg-6">
					<label>Friday</label>
				</div>
				<div className="col-lg-3">
					<input
						type="time"
						id="programname"
						className="form-control"
						value={friday_in}
						onChange={(event) => {
							setFriday_in(event.target.value);
						}}
					></input>
				</div>
				<div className="col-lg-3">
					<input
						type="time"
						id="programname"
						className="form-control"
						value={friday_out}
						onChange={(event) => {
							setFriday_out(event.target.value);
						}}
					></input>
				</div>
				<div className="col-lg-6">
					<label>Saturday</label>
				</div>
				<div className="col-lg-3">
					<input
						type="time"
						id="programname"
						className="form-control"
						value={saturday_in}
						onChange={(event) => {
							setSaturday_in(event.target.value);
						}}
					></input>
				</div>
				<div className="col-lg-3">
					<input
						type="time"
						id="programname"
						className="form-control"
						value={saturday_out}
						onChange={(event) => {
							setSaturday_out(event.target.value);
						}}
					></input>
				</div>
				<div className="col-lg-6">
					<label>Sunday</label>
				</div>
				<div className="col-lg-3">
					<input
						type="time"
						id="programname"
						className="form-control"
						value={sunday_in}
						onChange={(event) => {
							setSunday_in(event.target.value);
						}}
					></input>
				</div>
				<div className="col-lg-3">
					<input
						type="time"
						id="programname"
						className="form-control"
						value={sunday_out}
						onChange={(event) => {
							setSunday_out(event.target.value);
						}}
					></input>
				</div>
			</div>
			<br></br>
			<button className="btn btn-danger btn-sm" onClick={props.closeModal}>
				Cancel
			</button>
			<button
				className="btn btn-success pull-right btn-sm"
				onClick={props.action == "Add New Club" ? saveClub : updateClub}
			>
				Save
			</button>
			{isLoadingModal ? (
				<div>
					<img src={Wait} alt="Ball" width="25px" />
					Processing, please wait...
				</div>
			) : (
				""
			)}
			{error && (
				<Alert key={"danger"} variant={"danger"}>
					{error}
				</Alert>
			)}
		</Modal>
	);
}

export default ClubModal;
